const init = {
    Login: false,
    DatosUsuario: null,
    EsMobile: false,
    IsBusy: false,
    Books: {
        btc_mxn: {
            CompraPorcentaje: 5,
            VentaPorcentaje: 5
        },
    },
    MonitorOrdenes: []
}
export const inicioReducer = (state = init, action) => {
    switch (action.type) {
        case typesInicio.Login: return { ...state, Login: true }
        case typesInicio.Salir: return init;
        case typesInicio.SetDatosUsuario: return { ...state, DatosUsuario: action.payload }
        case typesInicio.MobileState: return { ...state, EsMobile: action.payload }
        case typesInicio.BusyState: return { ...state, IsBusy: action.payload }
        case typesInicio.SetBook:
            let _ns = { ...state };
            if (!_ns.Books) { _ns.Books = {}; }
            if (!_ns.Books[action.payload.Book]) { _ns.Books[action.payload.Book] = {}; }
            _ns.Books[action.payload.Book].CompraPorcentaje = action.payload.Compra;
            _ns.Books[action.payload.Book].VentaPorcentaje = action.payload.Venta;
            return _ns;
        case typesInicio.MonitorOrdenes: return { ...state, MonitorOrdenes: action.payload }
        default: return state;
    }
}
/* ### Actions ### */
export const LoginInicio = (params) => { return { type: typesInicio.Login } }
export const SalirApp = () => { return { type: typesInicio.Salir } }
export const SetDatosUsuarios = (datosUsuario) => { return { type: typesInicio.SetDatosUsuario, payload: datosUsuario } }
export const SetMobileState = (esMobile) => { return { type: typesInicio.MobileState, payload: esMobile } }
export const ShowBusy = (show = true) => { return { type: typesInicio.BusyState, payload: show } }
export const SetBook = (payload) => { return { type: typesInicio.SetBook, payload } }
export const SetOrdenesActivas = (ordenes) => { return { type: typesInicio.MonitorOrdenes, payload: ordenes } }
/* ### Actions ### */

/* ### Types de Inicio ### */
export const typesInicio = {
    Login: '[Inicio] Login',
    Salir: '[Inicio] Salir',
    SetDatosUsuario: '[Inicio] SetDatosUsuario',
    MobileState: '[Inicio] SetMobileState',
    BusyState: '[Inicio] BusyState',
    SetBook: '[Inicio] SetBook',
    MonitorOrdenes: '[Inicio] Monitor de Ordenes',
}
/* ### Types de Inicio ### */